'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { usePathname } from 'next/navigation';
import { useShallow } from 'zustand/react/shallow';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
import { useGlobalStore } from '@/stores/GlobalStore';
export const LoginRedirectionConfirmModal = () => {
  const $ = _c(16);
  const router = useCustomRouter();
  const pathname = usePathname();
  const [isShowLoginRedirectionConfirmModal, setIsShowLoginRedirectionConfirmModal] = useGlobalStore(useShallow(_temp));
  let t0;
  if ($[0] !== setIsShowLoginRedirectionConfirmModal) {
    t0 = () => setIsShowLoginRedirectionConfirmModal(false);
    $[0] = setIsShowLoginRedirectionConfirmModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useOverlayHistory(isShowLoginRedirectionConfirmModal, t0);
  let t1;
  if ($[2] !== pathname || $[3] !== router || $[4] !== setIsShowLoginRedirectionConfirmModal) {
    t1 = () => {
      setIsShowLoginRedirectionConfirmModal(false);
      router.push(ROUTES.LOGIN.withSearchParams({
        searchParams: {
          redirect: pathname ?? ""
        }
      }));
    };
    $[2] = pathname;
    $[3] = router;
    $[4] = setIsShowLoginRedirectionConfirmModal;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleClickConfirm = t1;
  let t2;
  if ($[6] !== setIsShowLoginRedirectionConfirmModal) {
    t2 = () => {
      setIsShowLoginRedirectionConfirmModal(false);
    };
    $[6] = setIsShowLoginRedirectionConfirmModal;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClose = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="mb-8 font-700 text-Gray-900 typo-body1">알림</p>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="mb-24 font-400 text-Gray-700 typo-body3">웰로에 회원가입을 하시고<br />정책 지원금을 확인해 보세요.</p>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleClickConfirm) {
    t5 = <Button className="cursor-pointer px-16 py-12 font-700 typo-body3" theme="primary-fill" onClick={handleClickConfirm}>웰로 시작하기</Button>;
    $[10] = handleClickConfirm;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleClose || $[13] !== isShowLoginRedirectionConfirmModal || $[14] !== t5) {
    t6 = <Modal className="flex flex-col items-center" opened={isShowLoginRedirectionConfirmModal} onClose={handleClose}>{t3}{t4}{t5}</Modal>;
    $[12] = handleClose;
    $[13] = isShowLoginRedirectionConfirmModal;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp(state) {
  return [state.isShowLoginRedirectionConfirmModal, state.setIsShowLoginRedirectionConfirmModal] as const;
}